export default __webpack_public_path__ + "072b9ca50f1b6cd5bd43f894a5f2aec9.jpg";